<template>
  <div class="p-2">
    <v-card elevation="0" class="summary-list-card">
      <v-card-title class="d-flex align-center justify-space-between px-4 py-3">
        <span class="text-subtitle-1 font-weight-bold">{{ title }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-progress-linear v-if="loading" indeterminate color="primary" />

      <v-data-table
        v-else
        :headers="table.headers"
        :items="row"
        :items-per-page-options="[3, 5, 10]"
        :items-per-page="3"
        no-data-text="No data available."
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <router-link
                target="_blank"
                name="stoke-view"
                :to="{ path: '/stock/view', query: { id: item.code } }"
              >
                {{ item.name }}
              </router-link>
            </td>
            <td :class="item.market_change_percent >= 0 ? 'text-success' : 'text-error'">
              {{ $helper.formatPercentage(item.market_change_percent / 100) }}
            </td>
            <td :class="item.market_change >= 0 ? 'text-success' : 'text-error'">
              {{ $helper.formatPrice(item.market_change) }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Summary-table',
  props: {
    title: { type: String },
    row: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: true,
      table: {
        headers: [
          { title: 'Name', key: 'name' },
          { title: 'Change(%)', key: 'market_change_percent', type: 'currency' },
          { title: 'Change', key: 'market_change', type: 'currency' },
        ]
      }
    };
  },
  watch: {
    row() {
      // Any change means the API response has arrived, whether or not it
      // actually contains rows -- gating this on length > 0 left the spinner
      // spinning forever for any category that legitimately has zero
      // results (e.g. no stocks lost value today).
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.summary-list-card {
  border: 1px solid var(--border);
  border-radius: 12px;
}
</style>